import React, { useState } from 'react';

// Renamed from original 'Input' to avoid naming conflicts
export const TextInput = ({ 
  label, 
  error, 
  name, 
  type = 'text',
  helperText,
  showPasswordToggle,
  ...props 
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputId = props.id || name;
  const isPassword = type === 'password';

  return (
    <div>
      {label && (
         <label htmlFor={inputId} className="block text-sm font-medium text-muted-foreground mb-2">
           {label}
         </label>
      )}
      <div className="relative">
        <input
          id={inputId}
          name={name}
          type={isPassword && showPassword ? 'text' : type}
          {...props}
          className={`w-full px-3.5 py-2.5 rounded-lg transition-all duration-200 focus:outline-none border ${
            error 
              ? 'border-danger focus:border-danger focus:ring-2 focus:ring-danger/20' 
              : 'border-border/60 focus:border-accent focus:ring-2 focus:ring-accent/20'
          } bg-background-soft text-foreground placeholder:text-muted-foreground/60 ${
            isPassword && showPasswordToggle ? 'pr-10' : ''
          }`}
        />
        {isPassword && showPasswordToggle && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground focus:outline-none transition-colors text-sm"
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            {showPassword ? 'Hide' : 'Show'}
          </button>
        )}
      </div>
      {error && <p className="text-danger text-xs mt-2">{error}</p>}
      {helperText && !error && (
        <p className="text-muted-foreground/80 text-xs mt-2">{helperText}</p>
      )}
    </div>
  );
}; 